'use client';

import { BannerRoleSection } from '../../../vidu-stream/_components/BannerRoleSection';
import { S1BannerMobile } from './S1BannerMobile';
import { S1BannerParallax } from './S1BannerParallax';

export const S1PageClient = () => {
  return (
    <div className="pb-6">
      {/* pb-6(24px) + BannerRoleSection 自带的 mt-6(24px) = 48px，与「官方角色」标题距「我的角色」卡片区的 pb-12(48px) 对齐 */}
      <div className="mx-auto w-full max-w-[1440px] px-8 pb-6 sm:px-0">
        {/* banner 仅作展示，不可点击；sm 为 max-width:767px 的反向断点，故移动端/桌面端由纯 CSS 切换 */}
        <S1BannerParallax className="sm:hidden" />
        <S1BannerMobile />
      </div>
      <BannerRoleSection className="sm:px-0" origin="s" />
    </div>
  );
};
